{
  "familyId": "SWW-LEEN-FRANS",
  "questions": [
    {
      "id": "SWW-LEEN-FRANS-001",
      "familyId": "SWW-LEEN-FRANS",
      "module": "SpellingWW",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_frans_werkwoorden",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd van 'parkeren'? (ik ...)",
      "context": null,
      "options": ["parkeerde", "parkeertte", "parkeerte", "geparkeerd"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Franse leenwoorden VT", "content": "Parkeren: stam = parkeer. Kofschip: r zit NIET in kofschip → +de. Verleden tijd: parkeer + de = parkeerde.", "icon": "lightbulb"}}],
      "conceptId": "leen_frans_vt_parkeren",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Regel: Franse leenwoorden — verleden tijd. Stap 1: Het werkwoord 'parkeren' komt van het Franse 'parquer'. Stap 2: De stam is 'parkeer'. Stap 3: De laatste letter 'r' zit NIET in 't kofschip → -de. Stap 4: parkeer + de = parkeerde. Checkstrategie: Franse leenwoorden op -eren hebben stam op -eer, en r zit niet in kofschip → altijd -de.",
        "solutionSteps": ["Bepaal de stam: parkeren → parkeer", "Kofschip: r zit NIET in kofschip → -de", "parkeer + de = parkeerde", "Check: Franse -eren werkwoorden → stam op -eer → altijd -de"],
        "distractorExplanations": {
          "0": "Correct! Stam 'parkeer' + de = parkeerde. R zit niet in kofschip.",
          "1": "Hier is -tte gebruikt in plaats van -de. 'Parkeertte' gebruikt -te, maar 'r' zit NIET in 't kofschip. Dus -de: parkeerde. Misconceptie: kofschip verkeerd toepassen.",
          "2": "Hier is -te gebruikt. 'Parkeerte' gebruikt -te, maar 'r' zit NIET in 't kofschip. Dus -de: parkeerde. Misconceptie: kofschip verkeerd toepassen.",
          "3": "Hier is het voltooid deelwoord gebruikt. 'Geparkeerd' hoort bij 'hebben geparkeerd'. De vraag vraagt om verleden tijd: parkeerde."
        }
      }
    },
    {
      "id": "SWW-LEEN-FRANS-002",
      "familyId": "SWW-LEEN-FRANS",
      "module": "SpellingWW",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_frans_werkwoorden",
      "questionType": "multiple_choice",
      "question": "Wat is het voltooid deelwoord van 'douchen'?",
      "context": null,
      "options": ["gedoucht", "gedouchd", "gedouched", "gedouchte"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD van Franse leenwoorden", "content": "Douchen: stam = douch. De ch klinkt als sj. Kofschip: ch → +t. VD: ge + douch + t = gedoucht.", "icon": "lightbulb"}}],
      "conceptId": "leen_frans_vd_douchen",
      "variantIndex": 2,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Regel: voltooid deelwoord van Franse leenwoorden. Stap 1: Het werkwoord 'douchen' komt van het Franse 'douche'. Stap 2: De stam is 'douch'. Stap 3: Kofschip: 'ch' zit WEL in 't kofschip → +t. Stap 4: ge + douch + t = gedoucht. Checkstrategie: de Franse spelling 'ch' (sj-klank) blijft behouden.",
        "solutionSteps": ["Bepaal de stam: douchen → douch", "Kofschip: ch zit in kofschip → +t", "VD: ge + douch + t = gedoucht", "Check: Franse spelling 'ch' behouden ✓"],
        "distractorExplanations": {
          "0": "Correct! Ge + douch + t = gedoucht. Ch zit in kofschip → +t.",
          "1": "Hier is +d gebruikt in plaats van +t. 'Gedouchd' gebruikt -d, maar 'ch' zit WEL in 't kofschip → +t: gedoucht. Misconceptie: kofschip verkeerd toepassen.",
          "2": "Hier is de Engelse -ed uitgang gebruikt. 'Gedouched' mengt Engels en Nederlands. In het Nederlands: ge + stam + t/d. Dus: gedoucht. Misconceptie: Engelse grammatica toepassen.",
          "3": "Hier is de bijvoeglijke vorm gebruikt. 'Gedouchte' is de bijvoeglijke vorm (een gedouchte persoon). Het voltooid deelwoord zelf is: gedoucht."
        }
      }
    },
    {
      "id": "SWW-LEEN-FRANS-003",
      "familyId": "SWW-LEEN-FRANS",
      "module": "SpellingWW",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_frans_werkwoorden",
      "questionType": "multiple_choice",
      "question": "Vul in: Wij ... ons gisteren na de training. (masseren, verleden tijd meervoud)",
      "context": null,
      "options": ["masseerden", "masseertten", "maseerden", "gemasseerd"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Franse leenwoorden VT meervoud", "content": "Masseren: stam = masseer. Kofschip: r zit NIET in kofschip → +de(n). Meervoud: masseer + den = masseerden.", "icon": "lightbulb"}}],
      "conceptId": "leen_frans_vt_masseren",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Regel: Franse leenwoorden — verleden tijd meervoud. Stap 1: Het werkwoord 'masseren' komt van het Franse 'masser'. Stap 2: De stam is 'masseer' (dubbele s behouden!). Stap 3: Kofschip: r zit NIET in kofschip → -de(n). Stap 4: 'Wij' is meervoud: masseer + den = masseerden.",
        "solutionSteps": ["Bepaal de stam: masseren → masseer (dubbele s!)", "Kofschip: r zit NIET in kofschip → -de(n)", "'Wij' is meervoud → -den", "masseer + den = masseerden"],
        "distractorExplanations": {
          "0": "Correct! Stam 'masseer' + den = masseerden. R niet in kofschip → -den.",
          "1": "Hier is -tten gebruikt in plaats van -den. 'Masseertten' gebruikt -ten, maar 'r' zit NIET in 't kofschip. Dus -den: masseerden. Misconceptie: kofschip verkeerd toepassen.",
          "2": "Hier is een 's' weggelaten. 'Maseerden' mist een s. De stam is 'masseer' (met dubbele s, van het Franse 'masser'). Onthoud: de Franse spelling behouden.",
          "3": "Hier is het voltooid deelwoord gebruikt. 'Gemasseerd' hoort bij 'hebben gemasseerd'. De vraag vraagt om verleden tijd meervoud: masseerden."
        }
      }
    },
    {
      "id": "SWW-LEEN-FRANS-004",
      "familyId": "SWW-LEEN-FRANS",
      "module": "SpellingWW",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_frans_werkwoorden",
      "questionType": "multiple_choice",
      "question": "Wat is het voltooid deelwoord van 'controleren'?",
      "context": null,
      "options": ["gecontroleerd", "gecontrolert", "gecontroleet", "kontroleerd"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD van Franse leenwoorden", "content": "Controleren: stam = controleer. Kofschip: r zit NIET in kofschip → +d. VD: ge + controleer + d = gecontroleerd.", "icon": "lightbulb"}}],
      "conceptId": "leen_frans_vd_controleren",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Regel: voltooid deelwoord van Franse leenwoorden. Stap 1: Het werkwoord 'controleren' komt van het Franse 'contrôler'. Stap 2: De stam is 'controleer'. Stap 3: Kofschip: r zit NIET in kofschip → +d. Stap 4: ge + controleer + d = gecontroleerd.",
        "solutionSteps": ["Bepaal de stam: controleren → controleer", "Kofschip: r zit NIET in kofschip → +d", "VD: ge + controleer + d = gecontroleerd", "Check: Franse -eren werkwoorden → stam op -eer → altijd +d"],
        "distractorExplanations": {
          "0": "Correct! Ge + controleer + d = gecontroleerd. R niet in kofschip → +d.",
          "1": "Hier is de stam verkort. 'Gecontrolert' mist de dubbele e van de stam 'controleer'. De stam is 'controleer' (niet 'controler'): gecontroleerd. Misconceptie: de stam inkorten.",
          "2": "Hier is +t gebruikt in plaats van +d. 'Gecontroleet' gebruikt -t, maar 'r' zit NIET in 't kofschip → +d: gecontroleerd. Misconceptie: kofschip verkeerd toepassen.",
          "3": "Hier is de spelling 'vernederlandst'. 'Kontroleerd' schrijft 'c' als 'k', maar de Franse spelling met 'c' blijft behouden: controleren → gecontroleerd. Misconceptie: de Franse spelling aanpassen."
        }
      }
    },
    {
      "id": "SWW-LEEN-FRANS-005",
      "familyId": "SWW-LEEN-FRANS",
      "module": "SpellingWW",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_frans_werkwoorden",
      "questionType": "fill_in",
      "question": "Wat is het voltooid deelwoord van 'reserveren'? Typ het hele woord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {"acceptedAnswers": ["gereserveerd"], "caseSensitive": false, "placeholder": "ge..."},
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD van reserveren", "content": "Reserveren: stam = reserveer. Kofschip: r zit niet in kofschip → +d. VD: ge + reserveer + d = gereserveerd.", "icon": "lightbulb"}}],
      "conceptId": "leen_frans_vd_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Regel: voltooid deelwoord van Franse leenwoorden. Stap 1: Het werkwoord 'reserveren' komt van het Franse 'réserver'. Stap 2: De stam is 'reserveer'. Stap 3: Kofschip: r zit NIET in kofschip → +d. Stap 4: ge + reserveer + d = gereserveerd. Checkstrategie: alle Franse -eren werkwoorden hebben stam op -eer, en r zit niet in kofschip → altijd +d bij VD.",
        "solutionSteps": ["Bepaal de stam: reserveren → reserveer", "Kofschip: r zit NIET in kofschip → +d", "VD: ge + reserveer + d = gereserveerd"]
      }
    }
  ]
}